import { NzUploadFile } from 'ng-zorro-antd/upload';
import { Attachment, CaseDetailModel } from '../../../insights.interface';

export interface QuestionnairesPayload {
  caseId: number;
  planTypeId: number;
  caseAttachmentId?: number;
  attachmentName?: string;
  responses: QuestionAnswers[];
}

export interface QuestionAnswers {
  questionId: number;
  answerText: string;
  selectedOptionIds?: number[];
  caseAttachmentId?: number;
}

export interface QuestionnairesResponse {
  caseAttachmentId?: number;
  attachmentName?: string;
  responses: ResponseData[];
}

export interface ResponseData {
  questionId: number;
  questionText: string;
  answerTypeId: number;
  answerText: string;
}
export interface QuestionnairesAnswerResponse {
  questionId: number;
  questionText: string;
  answerValue: string;
  files: FileData[];
  planTypeId: number;
  caseAttachmentId: number;
  answerType: string;
  questionnaireName: string;
}

export interface FileData {
  id: number;
  fileUrl: string;
  displayName: string;
  fileName: string;
}

export interface ExtendedUploadFile extends NzUploadFile {
  fileId?: number;
  originFileObj: File;
}

export enum QuestionnaireMode {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
}

export interface ManageQuestionnaireDrawerParams {
  case: CaseDetailModel;
  mode: QuestionnaireMode.CREATE | QuestionnaireMode.EDIT;
  planTypeId: number;
  attachment: Attachment;
}

export interface QuestionFile {
  caseAttachmentId: number;
  createdDate: string;
  fileId: number;
  fileName: string;
  filePath: string;
  fileUrl: string;
  questionId: number;
  updatedDate: string;
}

export const allowedFileExtensions: string[] = [
  '.mp4',
  '.m4v',
  '.m4a',
  '.wav',
  '.pptx',
  '.ppt',
  '.xlsx',
  '.xls',
  '.docx',
  '.doc',
  '.mp3',
  '.pdf',
  '.tif',
  '.tiff',
];
